export const identifierForTask = ({ id, ics, start, recurrence_id }) => {
  if (id?.startsWith('temp-')) return id;
  return `${ics}/${recurrence_id || start}`;
};
